import { BUSINESS_TOOL_SECTIONS, BUSINESS_TOOL_SUB_SECTIONS } from 'constants/businessTool';

export const prefix =
  `${BUSINESS_TOOL_SECTIONS.OVERVIEW}.${BUSINESS_TOOL_SUB_SECTIONS.OVERVIEW.FINANCIAL_INFO}` as const;

export const FINANCIAL_INFO_NAMES = {} as const;

export interface IFinancialInfoOverviewForm {}

export const overviewFinancialInfoInitialValues: IFinancialInfoOverviewForm = {};
